import dynamic from 'next/dynamic';
import propTypes from 'prop-types';

const CategCard = dynamic(() => import('@/components/categ/CategCard'));
CategCard.displayName = 'CategCard';
const DynamicLayout = dynamic(() => import('@/components/layout/DynamicLayout'));
DynamicLayout.displayName = 'DynamicLayout';

const NB_SCROLLTO_DESC_RECURSION_MAX = 3;

export const CategHeader = ({ categ, descriptionRef, isDesktop, isMobileDevice }) => {
	/**
	 * Scroll to descriptionRef
	 * Call this function recursively if the "scrollTo" doesn't work (or the position)
	 * We can adjust the position to scroll to a position with an offset
	 * The number of recursive call is limited by a constant "NB_SCROLLTO_DESC_RECURSION_MAX"
	 *
	 * @param {number} offset Offset to apply to the descriptionRef position
	 * @param {*} iterationIndex Current index of the number of call to seeDescription recursively (for limit that number)
	 */
	const seeDescription = (offset = 0, iterationIndex = 0) => {
		window.scrollTo(0, descriptionRef.current.offsetTop + offset);
		if (isDesktop) {
			setTimeout(
				(itIndex) => {
					const eltTop = Math.round(descriptionRef.current.getBoundingClientRect().top);
					if (
						eltTop !== 0 &&
						eltTop !== descriptionRef.current.offsetTop &&
						window.innerHeight + window.scrollY < document.body.offsetHeight &&
						itIndex < NB_SCROLLTO_DESC_RECURSION_MAX
					) {
						seeDescription(eltTop, itIndex + 1);
					}
				},
				100,
				iterationIndex,
			);
		}
	};

	return (
		categ && (
			<>
				<CategCard categ={categ} isMobile={!isDesktop} seeDescription={seeDescription} />

				{categ.headerEspots?.length > 0 && (
					<div className="mil-mt-2">
						<DynamicLayout componentList={categ.headerEspots} isMobileDevice={isMobileDevice} withPadding={false} />
					</div>
				)}
			</>
		)
	);
};

CategHeader.propTypes = {
	categ: propTypes.object,
	descriptionRef: propTypes.object,
	isDesktop: propTypes.bool,
	isMobileDevice: propTypes.bool,
};

export default CategHeader;
